import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex h-full max-h-full flex-col" }
const _hoisted_2 = { class: "flex h-full flex-col gap-2 overflow-y-scroll p-2.5 pt-0" }

import { Ref, onBeforeUnmount, ref, watch } from 'vue';
import { RouteLocationNormalizedLoaded, Router, useRoute, useRouter } from 'vue-router';
import { BlackDesertItem } from '@blackdesertmarket/interfaces';
import { ListFilterData } from '@/interfaces/list-filter';
import { LoaderSize } from '@/enums/loader';
import { useLocationStore } from '@/stores/location';
import { UseItemFetchReturn, useItemFetch } from '@/composables/item/use-item-fetch';
import { UseListFilterReturn, useListFilter } from '@/composables/list-filter/use-list-filter';
import AppLoader from '@/components/Base/AppLoader/AppLoader.vue';
import ListFilter from '@/components/ListFilter/ListFilter.vue';
import ListItem from '@/components/ListItem/ListItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemList',
  props: {
  mainCategory: {
    type: Number,
    required: true,
  },
  subCategory: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const locationStore = useLocationStore();
const router: Router = useRouter();
const route: RouteLocationNormalizedLoaded = useRoute();

const loaded: Ref<boolean> = ref(false);
const itemList: Ref<BlackDesertItem[]> = ref([]);

const refetchCategoryItemList = (mainCategory: number, subCategory: number): Promise<void> => {
  locationStore.mainCategory = mainCategory;
  locationStore.subCategory = subCategory;
  locationStore.searchWord = '';

  const itemFetch: UseItemFetchReturn = useItemFetch(mainCategory, subCategory);

  return itemFetch.fetch().then((data: BlackDesertItem[]): void => {
    itemList.value = data;
    loaded.value = true;
  });
};

const handleListItemClick = (item: BlackDesertItem): void => {
  router.push({
    name: 'item',
    params: {
      id: item.id,
    },
  });
};

const handleListFilter = async (data: ListFilterData): Promise<void> => {
  const listFilter: UseListFilterReturn = useListFilter(data);

  await listFilter.processItemList({
    itemList: itemList,
    loaded: loaded,
    fallback(): Promise<void> {
      return refetchCategoryItemList(props.mainCategory, props.subCategory);
    },
  });
};

if (!itemList.value.length) {
  refetchCategoryItemList(props.mainCategory, props.subCategory);
}

onBeforeUnmount((): void => {
  if (route.name === 'item') {
    return;
  }

  locationStore.mainCategory = null;
  locationStore.subCategory = null;
  locationStore.searchWord = '';
});

watch(
  (): number[] => {
    return [props.mainCategory, props.subCategory];
  },
  (): void => {
    loaded.value = false;
    refetchCategoryItemList(props.mainCategory, props.subCategory);
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ListFilter, { onFilter: handleListFilter }),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList.value, (item) => {
          return (_openBlock(), _createBlock(ListItem, {
            key: item.id,
            item: item,
            onEffect: ($event: any) => (handleListItemClick(item))
          }, null, 8, ["item", "onEffect"]))
        }), 128))
      ])
    ]),
    (!loaded.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          size: _unref(LoaderSize).LARGE,
          overlay: ""
        }, null, 8, ["size"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})